<script setup lang="ts">
/** 資源水位條（CPU／記憶體／磁碟）。色階走 `lib/fleet.ts` 的門檻＝與後端告警界線一致。 */
import { computed } from 'vue'

import { fmtPct, meterLevel } from '@/lib/fleet'

const props = withDefaults(
  defineProps<{
    /** 短標籤（CPU／RAM／磁碟）；空字串＝不顯示標籤（掛載表用）。 */
    label?: string
    pct: number | null | undefined
    title?: string
  }>(),
  { label: '', title: undefined },
)

const level = computed(() => meterLevel(props.pct))
const width = computed(() => `${Math.max(0, Math.min(100, props.pct ?? 0))}%`)
</script>

<template>
  <div class="meter" :class="level" :title="title">
    <span v-if="label" class="m-label">{{ label }}</span>
    <span class="m-track"><span class="m-fill" :style="{ width }" /></span>
    <span class="m-val">{{ fmtPct(pct) }}</span>
  </div>
</template>

<style scoped>
.meter {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: var(--fs-11);
  color: var(--fg-3);
  line-height: 1.2;
}
.m-label {
  width: 34px;
  flex: none;
  color: var(--fg-4);
}
.m-track {
  flex: 1;
  min-width: 48px;
  height: 6px;
  border-radius: 999px;
  background: var(--bg-sunken);
  overflow: hidden;
}
.m-fill {
  display: block;
  height: 100%;
  border-radius: 999px;
  background: var(--brand-500);
  transition: width var(--dur-base) var(--ease);
}
.m-val {
  width: 36px;
  flex: none;
  text-align: right;
  font-variant-numeric: tabular-nums;
}
.meter.warn .m-fill {
  background: var(--warning);
}
.meter.warn .m-val {
  color: var(--warning);
}
.meter.bad .m-fill {
  background: var(--danger);
}
.meter.bad .m-val {
  color: var(--danger);
  font-weight: 600;
}
</style>
